module.exports = __webpack_public_path__ + "img/cake.23cc90fc.gif";